import { createStyles } from '@mantine/styles';

var useStyles = createStyles((theme) => ({
  title: {
    lineHeight: 1,
    padding: 0,
    margin: 0,
    fontWeight: 400,
    fontSize: theme.fontSizes.md
  }
}));

export default useStyles;
//# sourceMappingURL=ModalBaseTitle.styles.js.map
